import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { DomUtil } from "../../util/DomUtil";
import { EmailSignUpSuccessModal } from "../healioGlobal/EmailSignUpSuccessModal";
import {
    ITopicAlertLoadRequest
} from "../../models/TopicAlert/ITopicAlertLoadRequest";
import {
    ITopicAlertRegisterRequest
} from "../../models/TopicAlert/ITopicAlertRegisterRequest";
import {
    ITopicAlertSaveRequest
} from "../../models/TopicAlert/ITopicAlertSaveRequest";
import { EventUtil } from "../../util/EventUtil";
import { LocalStorageUtil } from "../../util/LocalStorageUtil";
import { PageContext } from "../../service/PageContext";
import { StringUtil } from "../../util/StringUtil";
import { UiUtil } from "../../util/UiUtil";
import { WyanokeUtil } from "../../util/WyanokeUtil";

export class EmailTopicAlert extends Component {
    public static readonly TopicAlertAddedEvent: string =
        "TopicAlertAddedEvent";
    private readonly addButton: HTMLElement;
    private readonly alreadyAddedButton: HTMLElement;
    private readonly dataStore = "TopicAlerts";
    private readonly dataStoreKey = "ListIds";
    private readonly errorDiv: HTMLElement;
    private readonly invalidClass = "is-invalid";
    private readonly subscribeButton: HTMLButtonElement;
    private readonly successDiv: HTMLElement;
    private _listTitle: string | null = null;
    private _listId: string | null = null;
    private _isSubscribed = false;
    private topicAlertStorage: LocalStorageUtil | null = null;
    private manageEmailLink: string | undefined;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.addButton = DomUtil.query(this._element, '[data-topic-button="not-subscribed"]');
        this.alreadyAddedButton = DomUtil.query(this._element, '[data-topic-button="subscribed"]');
        this.subscribeButton = DomUtil.query(this._element, '[data-action="subscribe"]');
        this.successDiv = DomUtil.query(this._element, '[data-topic-modal="success"]');
        this.errorDiv = DomUtil.query(this._element, '[data-topic-modal="failed"]');
        this.manageEmailLink = this._element.dataset.manageEmailLink;

        window.addEventListener(EmailTopicAlert.TopicAlertAddedEvent,
            () => this.handleTopicAlertAddedEvent());

        this.subscribeButton
            .addEventListener("click", ev => this.handleSubscribe(ev));

        const closeAlertButtons = DomUtil.queryAll<HTMLButtonElement>(this._element, '[data-button="close-alert-box"]')
        closeAlertButtons.forEach(closeAlertButton => {
            if (closeAlertButton != undefined && closeAlertButton != null) {
                closeAlertButton.addEventListener("click", ev => this.collapseEmailTopicAlertBox(ev));
            }
        })

        const manageEmailAlertLinks = document.querySelectorAll<HTMLAnchorElement>("a.manage-email-alert");
        manageEmailAlertLinks.forEach(alertLink => {
            if (alertLink) {
                alertLink.addEventListener("click", ev => this.redirectToManageEmail(ev))
            }
        })

        UiUtil.collapseDivOffTargetClick(this._element);
    }

    public async init(): Promise<void> {
        const context = this._pageContext;
        const service = context ? context.topicAlertService : null;
        await WyanokeUtil.loadUserProfile(true, true);
        const settingItem = DomUtil.query(this._element, "[data-setting-item]", false);

        if (!window.UserProfile || !settingItem || !service
            || !window.Context || !window.Context.docinfo
            || !window.Context.docinfo.primaryspecialtyid
            || !window.Context.docinfo.primarysubspecialtyid) {

            return;
        }

        const currentElement = this;
        $("div[data-modal='emailSignUpSuccess']").on('shown.bs.modal', function () {
            const manageEmailAlertLinks = $(this)[0].querySelectorAll<HTMLAnchorElement>("a.manage-email-alert");
            manageEmailAlertLinks.forEach(alertLink => {
                if (alertLink) {
                    alertLink.addEventListener("click", ev => currentElement.redirectToManageEmail(ev))
                }
            })
        });

        this.topicAlertStorage = new LocalStorageUtil(this.dataStore);

        const newswirefilters: {Key: string; Value: string}[] = [
            {
                Key: "Specialty",
                Value: window.Context.docinfo.primarysubspecialtyid
            }
        ];
        if (window.Context?.documentid) {
            newswirefilters.push({
                Key: "ContextItemId",
                Value: window.Context.documentid
            });
        }

        const topicAlertLoadRequest: ITopicAlertLoadRequest = {
            contactid: window.UserProfile.contactid || "00000000-0000-0000-0000-000000000000",
            newswirefilters,
            sectionfilters: [
                {
                    Key: "Show on Alert Page",
                    Value: "1"
                },
                {
                    Key: "Specialty",
                    Value: window.Context.docinfo.primaryspecialtyid
                }
            ],
            startitemid: settingItem.dataset.settingItem || ""
        };

        const topicResponse =
            await service?.getTopicAlertWithStatus(topicAlertLoadRequest);

        if (!topicResponse) {
            return;
        }
        this._listTitle = topicResponse.Title;
        const topicTitles = DomUtil.queryAll<HTMLSpanElement>(this._element, '[data-content="topic-title"]');
        topicTitles.forEach(span => span.innerText = this._listTitle || "00000000-0000-0000-0000-000000000000");
        this._listId = topicResponse.ListId;
        this._isSubscribed =
            topicResponse.Subscribed === "1";

        if (!this._isSubscribed && window.UserProfile.isLoggedIn !== "True") {
            // check local storage for the listid for anonymous
            const addedTopicIds =
                this.topicAlertStorage?.getItem(this.dataStore,
                    [this.dataStoreKey]) as string;

            if (addedTopicIds && addedTopicIds.indexOf(this._listId) !== -1) {
                this._isSubscribed = true;
            }
        }
        // delete stored listids if loggedin
        if (window.UserProfile.isLoggedIn === "True") {
            this.topicAlertStorage?.deleteItem(this.dataStore,
                [this.dataStoreKey]);
        }

        if (this._isSubscribed) {
            this.showSubscribedButton();

            return;
        }
        this.showNotSubcribedButton(window.UserProfile.isLoggedIn === "True");
    }

    private collapseEmailTopicAlertBox(event: MouseEvent): void {
        const closeButton = event.target as Element;
        const innerAlertBox = closeButton.closest(".email-alert-inner");
        if (innerAlertBox && innerAlertBox.classList.contains("show")) {
            innerAlertBox.classList.remove("show");
        }
    }

    private async handleSubscribe(ev: Event): Promise<void> {
        const context = this._pageContext;
        const service = context ? context.topicAlertService : null;
        if (!window.UserProfile || !service || !this._listId) {
            console.warn("Unable to subscribe to Topic Alert. ListId, Service, or UserProfile not found");

            return;
        }

        // Known Users
        if (window.UserProfile.isLoggedIn === "True"
            && window.UserProfile.contactid) {
            UiUtil.toggleButtonState(this.subscribeButton);
            const topicAlertSaveRequest: ITopicAlertSaveRequest = {
                contactid: window.UserProfile.contactid,
                listid: this._listId,
                status: "2",
            };
            const savedTopic = await service.save(topicAlertSaveRequest);
            if (savedTopic && savedTopic === "True") {
                this.handleSuccess();

                return;
            }
            this.handleError();

            return;

        }
        // Non users that need to provide email
        const emailInput: HTMLInputElement =
            DomUtil.query(this._element, "input[type='email']", false);
        if (!emailInput) {
            console.warn("MISSING EMAIL INPUT FOR TOPIC ALERT SIGN UP");

            return;
        }

        emailInput.classList.remove(this.invalidClass);
        if (!StringUtil.isValidEmail(emailInput.value)) {
            emailInput.classList.add(this.invalidClass);

            return;
        }

        const crmHidden = DomUtil.query(this._element, "[data-crm-source]", false);
        if (!crmHidden || !crmHidden.dataset.crmSource) {
            console.warn("MISSING CRM SOURCE FOR TOPIC ALERT REGISTRATION");

            return;
        }

        UiUtil.toggleButtonState(this.subscribeButton);
        const topicAlertRegisterRequest: ITopicAlertRegisterRequest = {
            email: emailInput.value,
            listid: this._listId,
            source: crmHidden.dataset.crmSource,
        };

        const registerResponse =
            await service.register(topicAlertRegisterRequest);
        if (registerResponse && registerResponse !== undefined &&
            (registerResponse?.toLowerCase().indexOf("true") > -1 ||
                registerResponse?.toLowerCase().indexOf("existing") > -1)) {
            this.handleSuccess();
            await this.storeTopicListsForNonUsers(this._listId);

            return;
        }

        this.handleError();

    }

    private handleError(): void {
        UiUtil.toggleButtonState(this.subscribeButton);
        this._element.dispatchEvent(
            EventUtil.createCustomEvent(
                EmailSignUpSuccessModal.SignedUpForEmails,
                this.errorDiv.innerHTML.replace("d-none", "")));
    }

    private handleSuccess(): void {
        this._element.dispatchEvent(
            EventUtil.createCustomEvent(
                EmailTopicAlert.TopicAlertAddedEvent,
                null
            ));
        this._element.dispatchEvent(
            EventUtil.createCustomEvent(
                EmailSignUpSuccessModal.SignedUpForEmails,
                this.successDiv.innerHTML.replace("d-none", "")));
    }

    private handleTopicAlertAddedEvent(): void {
        this.addButton.remove();
        this.showSubscribedButton();
    }

    private redirectToManageEmail(ev: MouseEvent): void {
        ev.preventDefault();
        ev.stopPropagation();
        if (!this.manageEmailLink) {
            console.warn("Manage email link not passed to EmailTopicAlert Component")
            return;
        }
        var currentSubDomain = window.location.hostname.substr(0, window.location.hostname.indexOf("."))
        var healioSubDomain = currentSubDomain === "cme" ? "www" : currentSubDomain.replace("cme", "");
        window.location.href = window.location.origin.replace(currentSubDomain, healioSubDomain) + this.manageEmailLink;

    }

    private showSubscribedButton(): void {
        this.alreadyAddedButton.classList.remove("d-none");
        this._element.classList.remove("d-none");
    }

    private showNotSubcribedButton(isUser: boolean): void {
        const knownLanguage = DomUtil.query(this._element, '[data-sign-up-type="known"]', false);
        const unknownLanguage = DomUtil.query(this._element, '[data-sign-up-type="unknown"]', false);

        if (!knownLanguage || !unknownLanguage) {
            return
        }

        if (isUser) {
            unknownLanguage.remove();
            knownLanguage.classList.remove("d-none");
        } else {
            knownLanguage.remove();
            unknownLanguage.classList.remove("d-none");
        }
        this.addButton.classList.remove("d-none");
        this._element.classList.remove("d-none");
    }

    private async storeTopicListsForNonUsers(listid: string): Promise<void> {
        let storedIds = this.topicAlertStorage?.getItem(this.dataStore,
            [this.dataStoreKey]) as string;
        if (storedIds && typeof (storedIds) === "string") {
            storedIds += "|" + listid;
        } else {
            storedIds = listid;
        }
        this.topicAlertStorage?.insertItem(this.dataStore,
            [this.dataStoreKey], storedIds);
    }
}
ComponentFactory.registerComponent("EmailTopicAlert", EmailTopicAlert);
